import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-953eb524.js';
import './chunk-36c7966f.js';
import './chunk-1f5e2a99.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-ed52317d.js';
import './chunk-ade7667b.js';
import './chunk-f1608931.js';
import './chunk-42f463e6.js';
import './chunk-0d253c8b.js';
import './chunk-63dd07b4.js';
import './chunk-c8fb60ff.js';
import { T as Timepicker } from './chunk-95ac44e5.js';
export { T as BTimepicker } from './chunk-95ac44e5.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);
export default Plugin;